export default{
    setting: {
        index: 'setting-index',
    }
}